import { VariableGroup } from '../enum/variable-card.enum';
import { VariableValue } from './variable-value.model';

export class Parking extends VariableValue {
  public variableGroup: VariableGroup = VariableGroup.PARKING;
  constructor(parking: Partial<Parking>) {
    super();
    Object.assign(this, parking);
  }
}
